<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('feedback') }}
    </h1>
  
    <div class="main_wrap">
        <div class="mobiSection">
            <!-- <div class="mobiSection__header">
                <h2 class="mobiTitle md text_color"><span>Contact Us</span></h2>
                
                </div> -->
            <div class="mobiSection__content">
                <div class="mobiForm">
                     <h2 class="mobiTitle sm text_color"><span>{{ $t('feedback_intro') }}</span></h2>
                     <div class="mobiForElm">
                         <label>{{ $t('Overall') }}</label>
                        <div class="mobiForElm__wrap">
                            <star-rating
                              id="rating1"
                              :inline="true"
                              :star-size="24"
                              :increment="0.01"
                              active-color="#ffb902"
                              :show-rating="false"
                              :border-width="2"
                              border-color="#feb801"
                              :rounded-corners="false"
                              inactive-color="transparent"
                              :star-points="[
                                23,
                                2,
                                14,
                                17,
                                0,
                                19,
                                10,
                                34,
                                7,
                                50,
                                23,
                                43,
                                38,
                                50,
                                36,
                                34,
                                46,
                                19,
                                31,
                                17
                              ]"
                              @rating-selected="rating1 = $event" :rating="rating1"
                            ></star-rating>
                        </div>
                    </div>
                    <div class="mobiForElm">
                         <label>{{ $t('content') }}</label>
                        <div class="mobiForElm__wrap">
                            <star-rating
                              id="rating2"
                              :inline="true"
                              :star-size="24"
                              :increment="0.01"
                              active-color="#ffb902"
                              :show-rating="false"
                              :border-width="2"
                              border-color="#feb801"
                              :rounded-corners="false"
                              inactive-color="transparent"
                              :star-points="[
                                23,
                                2,
                                14,
                                17,
                                0,
                                19,
                                10,
                                34,
                                7,
                                50,
                                23,
                                43,
                                38,
                                50,
                                36,
                                34,
                                46,
                                19,
                                31,
                                17
                              ]"
                              @rating-selected="rating2 = $event" :rating="rating2"
                            ></star-rating>
                        </div>
                    </div>
                      <div class="mobiForElm">
                         <label>{{ $t('Usability') }}</label>
                        <div class="mobiForElm__wrap">
                            <star-rating
                              id="rating3"
                              :inline="true"
                              :star-size="24"
                              :increment="0.01"
                              active-color="#ffb902"
                              :show-rating="false"
                              :border-width="2"
                              border-color="#feb801"
                              :rounded-corners="false"
                              inactive-color="transparent"
                              :star-points="[
                                23,
                                2,
                                14,
                                17,
                                0,
                                19,
                                10,
                                34,
                                7,
                                50,
                                23,
                                43,
                                38,
                                50,
                                36,
                                34,
                                46,
                                19,
                                31,
                                17
                              ]"
                              @rating-selected="rating3 = $event" :rating="rating3"
                            ></star-rating>
                        </div>
                    </div>
                    <div class="mobiForElm lg">
                         <label>{{ $t('Your Suggestion') }}</label>
                         <textarea rows="4" cols="50"  :placeholder="$t('feedback_comment')"></textarea>
                    </div>

                </div>
                 <div class="btnContainer">
                        <button type="submit" class="mobiBtn">{{$t("submit")}}</button>
                </div>
             
            </div>
        </div>
    </div>  
    
  </div>
</template>

<script>
import Vue from "vue";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
export default {
  data(){
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0
    }
  },
  components:{
    StarRating
  },
  mounted(){
    const rating1 = document.getElementById("rating1");
    const rating2 = document.getElementById("rating2");
    const rating3 = document.getElementById("rating3");

    rating1.addEventListener("click", e => {
      this.rating1
    });

    rating2.addEventListener("click", e => {
      this.rating2
    });

    rating3.addEventListener("click", e => {
      this.rating3
    });
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/prizeo/Feedback.vue